// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "monaco-editor" + "." + "8d3c6381d437aa20729a" + ".css";
};